<template>
  <div class="persons-wrapper">
    <BaseCropper v-show="showCropper" @close="showCropper = false" @captured="photosSelected.push($event)" :img-url="selectedImg"/>
    <el-dialog
      :key="rerenderkey + 1"
      :show-close="false"
      :visible.sync="createPersonModal.open"
      top="20px"
      width="568px">
      <div slot="title" class="acr-bold-22">Add Person’s Info</div>
      <div class="close-video" @click="createPersonModal = { open: false, showSuccess: false }" style="background-color: transparent;color: #00204D;">
        <svgicon name="Close"></svgicon>
      </div>
      <div class="settings-form" v-if="createPersonModal.open">
        <div class="settings-field">
          <div class="settings-label acr-bold-18">
            Name
          </div>
          <input type="text" class="settings-input" placeholder="Write a name" v-model="nameSelected">
        </div>
        <div class="settings-field">
          <div class="settings-label acr-bold-18">
            Select tag(s)
          </div>
          <div class="settings-tags">
            <div class="settings-tag"
                 :class="{'active': tagsSelected.includes(item)}"
                 @click="tagsSelected.includes(item) ? tagsSelected = tagsSelected.splice(index, 1) : tagsSelected.push(item)"
                 v-for="(item, index) in tagsAvailable" :key="item + index">{{item}}</div>
            <el-popover
              :visible-arrow="false"
              placement="bottom-start"
              popper-class="persons-footer__preview-pop"
              transition="none"
              width="261"
              :close-delay="0"
              v-model="addTag.visible"
              trigger="click">
              <div class="persons-footer__preview-pop-head">
                <span>Create new tag</span>
                <svgicon name="Close" @click="cancelSelection(addTag)"></svgicon>
              </div>
              <div class="persons-footer__preview-pop-body">
                <div style="display:flex;">
                  <input type="text" v-model="addTag.value">
                  <div class="settings-tag__add-confirm" @click="addNewTag">
                    <svgicon name="Arrow-right"></svgicon>
                  </div>
                </div>
              </div>
              <div class="settings-tag settings-tag__add" slot="reference">
                <span>+</span>
              </div>
            </el-popover>


          </div>
        </div>
        <div class="settings-field" v-if="photosSelected.length > 0">
          <div class="settings-label acr-bold-18">
            Selected photo(s)
          </div>
          <div class="settings-previews">
            <div  v-for="item in mappedPhotos" :key="item.url" style="position: relative">
              <template :scope="item">
                <el-popover
                  :visible-arrow="false"
                  placement="right-start"
                  popper-class="persons-footer__preview-pop"
                  transition="none"
                  :offset="-50"
                  width="250"
                  :close-delay="0"
                  @after-enter="selectedToDelete = item.url"
                  @hide="selectedToDelete = ''"
                  v-model="item.visible"
                  trigger="click">
                  <div class="persons-footer__preview-pop-head">
                    <span>Delete this photo</span>
                    <svgicon name="Close" @click="cancelSelection(item)"></svgicon>
                  </div>
                  <div class="persons-footer__preview-pop-body">
                    <div class="persons-footer__preview-pop-btn" @click="cancelSelection(item)">Cancel</div>
                    <div class="persons-footer__preview-pop-btn red" @click="removePhotoFromSelected(item)">Delete</div>
                  </div>
                  <div class="persons-footer__preview" slot="reference">
                    <img :src="item.url" alt=""
                         class="persons-footer__preview-img"
                         :class="{'persons-footer__preview--delete': selectedToDelete === item.url}">
                    <svgicon name="Delete" :class="{'persons-footer__preview--delete': selectedToDelete === item.url}"></svgicon>
                  </div>
                </el-popover>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="persons-modal__footer" slot="footer">
        <div class="persons-modal__btn" @click="createPersonModal = { open: false, showSuccess: false }">Cancel</div>
        <div class="persons-modal__btn grey" :class="{'green': nameSelected.length > 0}" @click.prevent="createNewPerson">Updates person</div>
      </div>
    </el-dialog>
    <el-dialog
      :key="rerenderkey + 3"
      :show-close="false"
      :visible.sync="deletePersonModal.open"
      width="568px">
      <div slot="title" class="acr-bold-22" style="max-width: 308px">Are you sure you want to delete this person?</div>
      <div class="close-video" @click="deletePersonModal = { open: false }" style="background-color: transparent;color: #00204D;">
        <svgicon name="Close"></svgicon>
      </div>
      <div class="persons-group__card" style="margin-bottom: 30px">
        <img src="../../assets/img/abbie.png" alt="" class="persons-group__img">
        <div style="flex-grow: 1">
          <div class="persons-group__name acr-bold">Abbie</div>
          <div class="persons-group__tags">
            <div class="persons-group__tag">Asd</div>
            <div class="persons-group__tag">Qwexzc</div>
          </div>
        </div>
      </div>
      <div class="persons-modal__footer" slot="footer">
        <div class="persons-modal__btn" @click="deletePersonModal = { open: false }">Cancel</div>
        <div class="persons-modal__btn grey red" @click.prevent="deletePersonModal = { open: false }">Delete person</div>
      </div>
    </el-dialog>
    <div class="persons">
      <div class="persons-header">
        <div class="persons-header__add">
          <img src="../../assets/img/preview.png" alt="" class="persons-header__img">
          <div class="persons-header__title acr-bold-18" style="margin-top: -2px;margin-right: 17px">Abbie</div>
        </div>
        <div class="persons-header__edit" @click="createPersonModal = { open: true }">
          <svgicon name="Edit"></svgicon>
          <span>Edit</span>
        </div>
      </div>

      <div style="display:flex;justify-content: space-between">
        <BaseScrollbar>
          <div class="persons-bar__title acr-bold-18 border" style="padding-left: 70px">41 photos</div>
          <div class="persons-content condensed content-wrapper">
            <div class="persons-footer__preview" v-for="item in 41" :key="item" @click="selectedToDelete.push(item)">
              <img src="../../assets/img/preview.png" alt=""
                   class="persons-footer__preview-img"
                   :class="{'persons-footer__preview--delete': selectedToDelete.includes(item)}">
              <svgicon name="Delete" :class="{'persons-footer__preview--delete': selectedToDelete.includes(item)}"></svgicon>
            </div>
          </div>
        </BaseScrollbar>
        <div class="persons-bar">
          <div class="persons-bar__title acr-bold-18">Tags</div>
          <div class="settings-tags person-bar__tags">
            <div class="settings-tag active selected">The bunkres</div>
            <div class="settings-tag active selected">Driver</div>
          </div>
          <div class="persons-bar__title acr-bold-18">Detected in projects</div>
          <div class="persons-bar__detection">
            <svgicon name="Bar-chart"></svgicon>
            <span>Brands Hatch ‘21</span>
          </div>
          <div class="persons-bar__detection">
            <svgicon name="Bar-chart"></svgicon>
            <span>Hockenheimring ‘21</span>
          </div>
          <div class="persons-bar__detection">
            <svgicon name="Bar-chart"></svgicon>
            <span>TT Circuit Assen ‘21</span>
          </div>
        </div>
      </div>
      <portal to="app">
        <footer class="footer" style="padding-top: 21px" v-if="photosSelected.length > 0 && createPersonModal.open === false" :key="rerenderkey">
          <div class="footer-header">
            <div class="footer-title acr-bold-22">Selected photos</div>
            <div class="persons-footer__btn" @click="createPersonModal = { open: true }">Create person</div>
          </div>
          <div class="persons-footer">
            <div class="persons-footer__upload">
              <svgicon name="File-upload"></svgicon>
              <input type="file" class="persons-footer__upload-input" @change="uploadPhoto">
            </div>
            <div  v-for="item in mappedPhotos" :key="item.url" style="position: relative">
              <template :scope="item">
                <el-popover
                  :visible-arrow="false"
                  placement="right-start"
                  popper-class="persons-footer__preview-pop"
                  transition="none"
                  :offset="-50"
                  width="250"
                  :close-delay="0"
                  @after-enter="selectedToDelete = item.url"
                  @hide="selectedToDelete = ''"
                  v-model="item.visible"
                  trigger="click">
                  <div class="persons-footer__preview-pop-head">
                    <span>Delete this photo</span>
                    <svgicon name="Close" @click="cancelSelection(item)"></svgicon>
                  </div>
                  <div class="persons-footer__preview-pop-body">
                    <div class="persons-footer__preview-pop-btn" @click="cancelSelection(item)">Cancel</div>
                    <div class="persons-footer__preview-pop-btn red" @click="removePhotoFromSelected(item)">Delete</div>
                  </div>
                  <div class="persons-footer__preview" slot="reference">
                    <img :src="item.url" alt=""
                         class="persons-footer__preview-img"
                         :class="{'persons-footer__preview--delete': selectedToDelete === item.url}">
                    <svgicon name="Delete" :class="{'persons-footer__preview--delete': selectedToDelete === item.url}"></svgicon>
                  </div>
                </el-popover>
              </template>
            </div>
          </div>
        </footer>
      </portal>
    </div>
  </div>

</template>

<script>
import BaseScrollbar from '../../components/BaseScrollbar';
import BaseCropper from '../../components/BaseCropper';
import { mapGetters } from 'vuex';

export default {
  name: "Person",
  components: { BaseCropper, BaseScrollbar },
  data() {
    return {
      persons: [],
      tagsAvailable: [
        "Camera operator",
        "Careers adviser",
        "Careers consultant",
        "Cartographer",
        "Catering manager",
        "Charities administrator",
        "Chiropractor",
      ],
      tagsSelected: [],
      nameSelected: '',
      photosSelected: [],
      selectedToDelete: [],
      selectedImg: '',
      showCropper: false,
      rerenderkey: 0,
      createPersonModal: {
        open: false,
        showSuccess: false,
      },
      deletePersonModal: {
        open: false,
      },
      addTag: { visible: false, value: '' }
    }
  },
  computed: {
    ...mapGetters({
      projectTypes: 'projectTypes',
    }),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.projectTypes.includes('video_analytics')) {
        next()
      } else {
        next('/dashboard')
      }
    })
  },
}
</script>

<style scoped>

</style>
